export default __webpack_public_path__ + "static/media/event-bg.211d9862.jpg";